import Vue from "vue";
import Vuex from "vuex";
import { router } from "./modules/route";
import { auth } from "./modules/auth-user-modul";
import { hotelConfig } from "./modules/hotel-configuration";
import { orderModul } from "./modules/orders-modul";
import { settings } from "./modules/settings";
import { roomServiceModul } from "./modules/room-service";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    router,
    auth,
    hotelConfig,
    orderModul,
    settings,
    roomServiceModul,
  },
});
